import apiService from "./apiService";
import AppConstants from "../appConstants";

class PackageService {
    getAllPackage(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_PACKAGE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getPackageDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_PACKAGE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerPackage(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_PACKAGE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deletePackage(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_PACKAGE}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_PACKAGE_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new PackageService();
